import { render, staticRenderFns } from "./drawerData.vue?vue&type=template&id=f8221142"
import script from "./drawerData.vue?vue&type=script&lang=js"
export * from "./drawerData.vue?vue&type=script&lang=js"
import style0 from "./drawerData.vue?vue&type=style&index=0&id=f8221142&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8221142')) {
      api.createRecord('f8221142', component.options)
    } else {
      api.reload('f8221142', component.options)
    }
    module.hot.accept("./drawerData.vue?vue&type=template&id=f8221142", function () {
      api.rerender('f8221142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/ClientProfiles/components/drawerData.vue"
export default component.exports